<template>
  <div class="patients-list">
    <modal
      ref="deletePatient"
      template="question"
      title="Aviso"
      ref-name="deletePatient"
      first-button-text="Cancelar"
      second-button-text="Excluir"
      @first-cta="closeModal()"
      @second-cta="handleDelete()"
    >
      <p>Tem certeza que deseja excluir o paciente?</p>
      <div class="patients-list__modal-text">
        <span v-html="selectedItem ? selectedItem.name : ''" />
      </div>
    </modal>

    <InfiniteLoading
      v-if="filteredArray && filteredArray.length > 0"
      :list="filteredArray"
      :items-per-scroll="20"
      @load-more="loadMore"
      @update-list="updateList"
    />

    <div
      v-if="patientIsLoading"
      class="loading"
    >
      <spinner />
    </div>
    <div v-else>
      <data-table
        v-if="filteredArray && filteredArray.length > 0"
        :header="table.header"
        is-sticky
      >
        <div
          v-for="(patient, index) in listItems"
          :key="index"
          class="data-table__body__row"
          @click="showDetail(patient.id, $event)"
        >
          <!-- name cell -->
          <data-cell :size="20">
            <p class="name ellipsable">
              {{ patient.name }}
              <md-tooltip md-direction="top">
                {{ patient.name }}
              </md-tooltip>
            </p>
          </data-cell>

          <!-- cpf cell -->
          <data-cell :size="15">
            <p class="regular ellipsable">
              {{ patient.cpf }}
              <md-tooltip md-direction="top">
                {{ patient.cpf }}
              </md-tooltip>
            </p>
          </data-cell>

          <!-- email cell -->
          <data-cell :size="15">
            <p class="regular ellipsable">
              {{ patient.email }}
              <md-tooltip md-direction="top">
                {{ patient.email }}
              </md-tooltip>
            </p>
          </data-cell>

          <!-- birthdate cell -->
          <data-cell :size="15">
            <p class="regular ellipsable">
              {{ patient.birthDate }}
              <md-tooltip md-direction="top">
                {{ patient.birthDate }}
              </md-tooltip>
            </p>
          </data-cell>

          <!-- gender cell -->
          <data-cell
            :size="15"
            class="subtract-cell"
          >
            <p class="regular ellipsable">
              {{ patient.gender }}
              <md-tooltip md-direction="top">
                {{ patient.gender }}
              </md-tooltip>
            </p>
          </data-cell>

          <!-- action cell -->
          <data-cell
            :size="15"
            class="actions-cell"
          >
            <div class="actions-container">
              <!-- create OS action -->
              <div
                id="createOS"
                class="status-icon icon-create-os"
                @click="$router.push('/orders/patient/' + patient.id)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Adicionar Ordem de Serviço
                </md-tooltip>
              </div>

              <!-- edit action -->
              <div
                class="status-icon icon-edit-alt"
                @click="handleEdit(patient)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Editar
                </md-tooltip>
              </div>

              <!-- delete action -->
              <div
                id="delete"
                class="status-icon icon-delete-alt"
                @click="openDeleteModal(patient)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
              </div>
            </div>
          </data-cell>

          <!-- show detail cell -->
          <data-cell
            :size="5"
            class="detail-cell"
          >
            <img
              src="/static/images/icon-arrow-dropdown-alt.svg"
              :class="{'patients-list__detail-row--active': patient.showDetail}"
              alt="icone-ver-mais"
            >
          </data-cell>

          <PatientDetail
            :doctors="patient.doctors"
            :show="patient.showDetail"
          />
        </div>
      </data-table>
      <div
        v-if="filteredArray && filteredArray.length === 0 && !patientIsLoading"
        class="no-results"
      >
        <div class="img-wrapper">
          <img
            src="/static/images/no-file-img.svg"
            alt="sem-resultados"
          >
        </div>
        <p>Nenhum paciente cadastrado.</p>
        <p>Para adicionar pacientes, selecione:</p>
        <button @click="$router.push('/patient/new')">
          NOVO PACIENTE
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PatientDetail from './PatientDetail'
import DataTable from '../common/dataTable/DataTable'
import DataCell from '../common/dataTable/DataCell'
import Spinner from '@/components/common/Spinner'
import InfiniteLoading from '@/components/common/InfiniteLoading'

import fuzzysort from 'fuzzysort'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PatientList',
  components: {
    PatientDetail,
    DataTable,
    DataCell,
    InfiniteLoading,
    Spinner
  },
  props: {
    filterInput: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      selectedItem: null,
      table: {
        header: [
          {
            title: 'Paciente',
            subtitle: 'Nome',
            size: 20
          },
          {
            title: 'CPF',
            subtitle: '',
            size: 15
          },
          {
            title: 'Email',
            subtitle: '',
            size: 15
          },
          {
            title: 'Nascimento',
            subtitle: 'Data',
            size: 15
          },
          {
            title: 'Sexo',
            subtitle: '',
            size: 15
          },
          {
            title: '',
            subtitle: '',
            size: 15
          },
          {
            title: '',
            subtitle: '',
            size: 5
          }
        ]
      },
      listItems: []
    }
  },
  methods: {
    ...mapActions(['patientGetAll']),
    ...mapActions(['patientDelete']),
    closeModal () {
      this.$refs.deletePatient.close()
    },
    openDeleteModal (item) {
      this.selectedItem = item
      this.$refs.deletePatient.open()
    },
    showDetail (id, event) {
      if (event.target.id !== 'delete') {
        this.filteredArray = this.filteredArray.map((item) => {
          if (item.id === id) {
            item.showDetail = !item.showDetail
          }
          return item
        })
      }
    },
    handleEdit (patient) {
      this.$router.push({
        path: '/patient/edit/' + patient.id
      })
    },
    handleDelete () {
      this.patientDelete(this.selectedItem)
      this.closeModal()
    },
    updateList (newList) {
      this.listItems = newList
    },
    loadMore (items) {
      items.forEach((item) => {
        this.listItems.push(item)
      })
    }
  },
  computed: {
    ...mapGetters(['patientIsLoading']),
    ...mapGetters(['patientList']),
    filteredArray: {
      get () {
        if (this.filterInput) {
          if (this.filterInput.length > 0) {
            let result = fuzzysort.go(this.filterInput, this.patientList, {
              keys: ['name', 'cpf', 'birthDate', 'gender', 'email'],
              limit: 100,
              allowTypo: true,
              threshold: -10000
            })
            result = result.map((item) => {
              item = item.obj
              return item
            })
            return result
          }
        } else {
          return this.patientList
        }
      },
      set (newVal) {
        return newVal
      }
    }
  },
  mounted () {
    this.patientGetAll()
  }
}
</script>

<style lang="scss">
.patients-list {
  margin-bottom: 40px;
  width: 100%;

  .actions-cell {
    width: 130px !important;
  }
  .detail-cell {
    width: 40px !important;
  }
  .subtract-cell {
    width: calc(35% - 170px) !important;
    min-width: 55px !important;
  }
  &__modal-text {
    text-align: center;
    padding: 15px;
    background: #f5f5f5;
    border-radius: 5px;

    span {
      font-weight: 500;
      font-size: 16px;
      color: #4a4a4a;
      letter-spacing: 0;
    }
  }

  &__show-detail {
    min-height: 58px;
    cursor: pointer;
  }

  .data-table {
    &__header {
      &__row {
        height: auto !important;
        &--sticky {
          height: 50px !important;
          display: flex;
          align-items: flex-end;
          padding-bottom: 10px;
        }
        &__cell {
          padding: 0 16px !important;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          margin-bottom: 5px;
        }
      }
    }
    &__body {
      &__row {
        width: 100%;
        min-height: auto !important;
        cursor: pointer;
        margin-bottom: 8px;
        box-shadow: 0px 1px 4px rgba(121, 121, 121, 0.12);

        &__cell {
          padding: 0 16px;

          p {
            cursor: pointer;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 26px;
            padding: 16px 0;
          }
        }
      }
    }
  }
  .actions-cell {
    padding: 0 !important;
  }

  &__detail-row {
    line-height: 26px;
    &--active {
      transform: rotate(180deg);
    }
  }

  .loading {
    min-height: 60vh;
    display: flex;
    align-items: center;
  }

  .no-results {
    color: #7a7a7a;
    text-align: center;
    min-height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    .img-wrapper {
      margin-bottom: 35px;
    }
    p {
      font-size: 16px;
      margin-bottom: 20px;
      &:first-of-type {
        font-size: 20px;
      }
    }
    button {
      font-size: 10px;
      color: #fff;
      font-weight: 500;
      background-color: #55cd9e;
      padding: 8px 16px;
      height: auto;
      margin: 10px 0;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .infinite-loading-container {
    min-height: 30vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ellipsable {
    font-size: 14px;
    text-transform: none;
    width: 100%;
    color: #4A4A4A;
  }
  .name {
    font-style: normal;
    font-weight: 500;
  }
  .regular {
    font-weight: normal;
  }

  .regular {
    font-weight: normal;
    font-size: 14px;
  }

  .actions {
    &-container {
      .icon-delete-alt,
      .icon-edit-alt {
        opacity: 0;
      }
      div {
        margin: 0 0.4em;
      }
    }
    &-cell {
      padding-left: 0;
    }
  }

  .data-table__body__row {
    min-height: 5.5em;
    &__cell {
      display: flex;
    }
    &:hover {
      .actions {
        &-container {
          .icon-delete-alt,
          .icon-edit-alt {
            opacity: 1;
          }
        }
      }
    }
  }
}
@media all and (max-width: 1024px) {
  .patients-list {
    .detail-cell {
      display: none !important;
    }
  }
}
</style>
